/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-06 10:30:38
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {SaasAccountConfigDOI} from "./api/saasAccountConfigApi";
import SaasAccountConfigService from "./service/saasAccountConfigService";
import './saasAccountConfig.less';

@Component({name: 'saas-account-config'})
export default class SaasAccountConfig extends BasicSearchPage<SaasAccountConfigService, SaasAccountConfigDOI.RowDataI, SaasAccountConfigDOI.QueryRowDataParamsI> {

    @override
    renderHead(h) {
        return <div></div>
    }
    
	@override
	loadService () {
		this.service = new SaasAccountConfigService(this)
	}
}